import { FooterComponent } from './components/footer/footer.component';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationRoutingModule } from './location-routing.module';
import { LocationComponent } from './location.component';
import { SharedModule } from '../../shared/shared.module';
import { ExpanderComponent } from './components/expander/expander.component';
import { LocationMapDetailsComponent } from './components/location-map-details/location-map-details.component';
import { HoursCardComponent } from './components/hours-card/hours-card.component';
import { HolidayHoursComponent } from './components/holiday-hours/holiday-hours.component';
import { StoreModule } from '@ngrx/store';
import * as fromLocation from './+state/location.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LocationEffects } from './+state/location.effects';
import { ProviderCardContainerComponent } from './components/provider-card-container/provider-card-container.component';
import { PhonePipe } from './pipes/phone.pipe';
import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { AddressComponent } from './components/address/address.component';
import { TransportationComponent } from './components/transportation/transportation.component';
import { VisitorInfoComponent } from './components/visitor-info/visitor-info.component';
import { MoreHoursCardComponent } from './components/more-hours-card/more-hours-card.component';

@NgModule({
  declarations: [
    LocationComponent,
    LocationMapDetailsComponent,
    ExpanderComponent,
    FooterComponent,
    HoursCardComponent,
    HolidayHoursComponent,
    ProviderCardContainerComponent,
    PhonePipe,
    SideNavigationComponent,
    ContactUsComponent,
    AddressComponent,
    TransportationComponent,
    VisitorInfoComponent,
    MoreHoursCardComponent
  ],
  imports: [
    CommonModule,
    LocationRoutingModule,
    SharedModule,
    StoreModule.forFeature(fromLocation.LOCATION_FEATURE_KEY, fromLocation.reducer),
    EffectsModule.forFeature([LocationEffects])
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LocationModule {}
